export const applicationUpdateDataList = async (data) => {
  let result = {
    id: data.id,
    broker_id: data.broker_id,
    invoice_amount: data.invoice_amount,
    fein_ssn: data.FEIN,
    dba: data.DBA !== undefined ? data.DBA : null,
    address: data.Street_Address, //todo
    applicant_name: data.Name,
    address_2_type: data.address2Type,
    address_2: data.Street_Address_Line_2, //todo
    business_started: data.Business_Start_Date,
    city: data.City,
    state: data.State,
    zip_code: data.ZipCode,
    date_industry_experience_started: data.Industry_Experience,
    fax: data.FAX,
    phone: data.Phone,
    email: data.Email,
    cell: data.Mobile,
    Is_Discounted: data.Is_Discounted,
    state_of_title: data.state_of_title,
    cdl_number: data.CDL_Number,
    sales_tax_exemption_number: data.sales_tax_exemption_number,
    cdl_expiration_date: data.CDL_Expiration_Date,
  };
  return result;
};

export const checkAssetType = async (application) => {
  let asset_type = "";
  if (application?.assets?.length > 0) {
    let highestValue = 0.0;
    let highestValueAsset = null;
    console.log("Is cashout", application.assets);
    // application?.assets?.map((item) => {
    //   let value = item?.nmef_equipment_value;
    //   if (value > highestValue || highestValueAsset === null) {
    //     highestValueAsset = item;
    //     highestValue = value;
    //   }
    // });

    if (highestValueAsset) asset_type = highestValueAsset.type;
  }
  console.log("Asset type", asset_type);
  return asset_type;
};
export const applicationDataListMap = async (application, fees) => {
  let result = {
    id: application.id,
    is_fifty_pre_funded: application.is_fifty_pre_funded,
    broker_id: application.broker_id,
    Broker_Name: application.broker?.name,
    Contract_Number: application.contract_number,
    Referral_Party_Id: application.referral_party_application_id,
    Broker_Program: application.broker?.program,
    Account_Manager: application.account_manager_id,
    invoice_amount: application.invoice_amount,
    FEIN: application.fein_ssn,
    DBA: application.dba !== undefined ? application.dba : "None",
    Business_Entity_Type: application.business_entity_type,
    Street_Address: application.address, //todo
    Name: application.applicant_name,
    address2Type: application.address_2_type, //todo
    Street_Address_Line_2: application.address_2, //todo
    Business_Start_Date: application.business_started,
    City: application.city,
    State: application.state,
    ZipCode: application.zip_code,
    Industry_Experience: application.date_industry_experience_started,
    FAX: application.fax,
    Phone: application.phone,
    Email: application.email,
    Mobile: application.cell,
    CDL_Expiration_Date: application.cdl_expiration_date,
    CDL_Number: application.cdl_number,
    sales_tax_exemption_number: application.sales_tax_exemption_number,
    Assets: application.assets,
    Is_Discounted: application.Is_Discounted,
    state_of_title: application.state_of_title,
    title_responsibility: application.title_responsibility,
    Fees: fees,
  };
  return result;
};

export const applicationDealDataList = (element) => {
  let result = {
    Selected_for_Proposal__c: element.selected_for_proposal,
    selected_for_submitted_deal: element.selected_for_submitted_deal,
    name: element.name,
    Structure__c: element.deal_structure,
    cfa__c: element.financed_amount,
    ccr__c: element.cap_cost_reduction,
    Payment__c: element.monthly_payment,
    Total_Due_To_NMEF__c: element.total_customer_due_at_signing, //TODO
    Total_Customer_Due_At_Signing__c: element.total_customer_due_at_signing,
  };
  return result;
};
export const applicationGuarantorDataList = (element) => {
  let result = {
    name:
      element.guarantor_type === "Personal"
        ? element.guarantor?.first_name + " " + element.guarantor?.last_name
        : element.guarantor?.organization_name,
    Percent_of_Ownership:
      element.guarantor_type
        ? element?.percent_of_ownership : 0,
    SSN_FEIN:
      element.guarantor_type === "Corporate"
        ? element.guarantor?.fein
        : element.guarantor?.ssn,
    Date_of_Birth:
      element.guarantor_type === "Corporate"
        ? "N/A"
        : element.guarantor?.date_of_birth,
    Phone: element.guarantor?.telephone,
    Marital_Status:
      element.guarantor_type === "Corporate"
        ? "N/A"
        : element.guarantor?.marital_status,
    Address:
      element.guarantor?.address +
      " " +
      element.guarantor?.city +
      ", " +
      element.guarantor?.state +
      " ," +
      element.guarantor?.zip_code,
  };
  return result;
};

export const checkInvoiceWithAssetFeeTotal = async (
  appInvoiceTotal,
  ApplicantData
) => {
  console.log("amount 1- ", appInvoiceTotal);
  var doesTotalMatch = false;
  var assetAndFeeTotal = 0;

  let assets = ApplicantData.Assets;
  console.log("Asset Price", assets);
  assets.forEach((element) => {
    assetAndFeeTotal += element.price;
  });

  let fees = ApplicantData.Fees;
  console.log("Fees", fees);
  fees.forEach((element) => {
    if (element.vendor)
      assetAndFeeTotal +=
        element.override_amount != null
          ? element.override_amount
          : element.amount;
  });
  console.log("amount 2- ", assetAndFeeTotal);
  if (parseInt(appInvoiceTotal) === parseInt(assetAndFeeTotal)) {
    doesTotalMatch = true;
  }
  return doesTotalMatch;
};
